import { useConfig } from "./utils.js";

const { platformURL } = useConfig();
const initialTS = Date.now();
let popupTS;
let role;

// Validations
const validateEmail = (email) =>
  /^(?=.*[@])(?=.*\.com)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    email,
  );
const validatePhone = (phone) => /^\d{10}$/.test(phone);
const validateDate = (date) =>
  /^\d{4}[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/.test(date);

const bodyClosePopup = (e) => {
  const popup = document.getElementById("signup-popup");
  const popupWindow = popup.querySelector(".popup-window");
  const popupElements =
    e.target === popupWindow ||
    popupWindow.contains(e.target) ||
    e.target.classList.contains("ui-icon") ||
    e.target.classList.contains("ui-datepicker-next") ||
    e.target.classList.contains("ui-datepicker-prev") ||
    e.target.classList.contains("ui-corner-all");

  if (!popupElements) {
    if (
      localStorage &&
      (!localStorage.email || localStorage.email !== "email")
    ) {
      localStorage.email = "closed";
      localStorage.emailTime = Date.now();
    }

    popup.style.display = "none";
    document.getElementById("signup-popup").setAttribute("aria-hidden", "true");
    document.getElementById("signup-popup").setAttribute("aria-modal", "false");
    document
      .getElementById("website-content")
      .setAttribute("aria-hidden", "false");
    document.querySelector("body").removeEventListener("click", bodyClosePopup);
    window.removeEventListener("keydown", window.focusTrap);
    window.focusReturn.focus();
  }
};

const escapeClose = (e) => {
  const isEscKey = e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
  if (isEscKey) closePopup();
};

const checkScroll = () => {
  const position = window.scrollY;
  const height = document.documentElement.scrollHeight;

  if (position > Math.round(height / 4)) {
    document.removeEventListener("scroll", checkScroll);
    setTimeout(() => {
      document.getElementById("screen-alerts").innerHTML = `
        <p>Focus changed to email popup. You can close this popup to return to your previous focus point.</p>
      `;

      document.getElementById("signup-popup").style.display = "flex";
      document
        .getElementById("signup-popup")
        .setAttribute("aria-hidden", "false");
      document
        .getElementById("signup-popup")
        .setAttribute("aria-modal", "true");
      document
        .getElementById("website-content")
        .setAttribute("aria-hidden", "true");
      document.removeEventListener("scroll", checkScroll);
      popupTS = Date.now();
      window.toTrap = document.getElementById("signup-popup");
      window.focusReturn = document.activeElement;
      document.getElementById("signup-popup").focus();
      window.addEventListener("keydown", escapeClose); // Add escapeClose as event listener
      window.addEventListener("keydown", window.focusTrap); // Add focusTrap on modal
    }, 1200);
    setTimeout(() => {
      document.querySelector(".email-popup").style.opacity = 1;
    }, 1215);
    setTimeout(() => {
      document.querySelector("body").addEventListener("click", bodyClosePopup);
    }, 1215);

    // Analytics
    gtag({
      event: "email_popup_email_screen_viewed",
      eventID: getEventId(),
      eventData: {
        pagedTriggered: window.location.pathname,
      },
    });
  }
};

if (window.location.href.includes("utm_source=klaviyo")) {
  localStorage.email = "email";
  localStorage.emailTime = Date.now();
}

if (
  localStorage &&
  (!localStorage.email ||
    (localStorage.email &&
      localStorage.emailTime &&
      localStorage.email === "closed" &&
      Date.now() - localStorage.emailTime > 2592000000))
) {
  document.addEventListener("scroll", checkScroll);
  document
    .getElementById("signup-popup")
    .querySelectorAll("img")
    .forEach((image) => {
      const img = new Image();
      img.src = image.src;
    });
}

document
  .querySelectorAll('.radios input[name="wedding-role"]')
  .forEach((radio) => {
    radio.addEventListener("change", function () {
      if (localStorage) {
        localStorage.role = this.value;
      }
      role = this.value;
    });
  });

const closePopup = () => {
  const popup = document.getElementById("signup-popup");
  if (localStorage && (!localStorage.email || localStorage.email !== "email")) {
    localStorage.email = "closed";
    localStorage.emailTime = Date.now();
  }
  popup.style.display = "none";
  document.getElementById("signup-popup").setAttribute("aria-hidden", "true");
  document.getElementById("signup-popup").setAttribute("aria-modal", "false");
  document
    .getElementById("website-content")
    .setAttribute("aria-hidden", "false");
  document.querySelector("body").removeEventListener("click", bodyClosePopup);
  window.removeEventListener("keydown", escapeClose); // Remove escapeClose as event listener
  window.removeEventListener("keydown", window.focusTrap); // Remove window.focusTrap as event listener
  window.focusReturn.focus();
};

const removeWarning = (e) => {
  e.currentTarget.classList.remove("check-validity");
  e.currentTarget.labels[0].style.color = "#464646";
  e.currentTarget.labels[0].style.opacity = "0";
};

document
  .getElementById("CustomerEmail")
  ?.addEventListener("input", removeWarning);
document
  .getElementById("PhoneNumber")
  ?.addEventListener("input", removeWarning);
document
  .getElementById("WeddingDate")
  ?.addEventListener("input", removeWarning);

const submitEmailPopup = (e) => {
  const button = e.currentTarget;
  const email = document.getElementById("CustomerEmail");
  const weddingDate = document.getElementById("WeddingDate");
  const verify = document.getElementById("verify");
  const problemElem = [];
  let valid = true;
  if (!validateEmail(email.value)) {
    email.classList.add("check-validity");
    email.labels[0].style.color = "var(--errorText)";
    email.labels[0].style.opacity = "1";
    valid = false;
    problemElem.push(email);
  } else {
    const container = e.target.closest(".popup-content");
    container.classList.add("hidden");
    container.nextElementSibling.classList.remove("hidden");
  }
  if (!validateDate(weddingDate.value) && weddingDate.value !== "") {
    weddingDate.classList.add("check-validity");
    weddingDate.labels[0].style.color = "var(--errorText)";
    valid = false;
    problemElem.push(weddingDate);
  }
  if (!valid) {
    problemElem[0].focus();
    return;
  }

  // Set the customer's email to use during SMS modal step
  sessionStorage.setItem("customerEmail", email.value);

  // Create data object to send to signup endpoint
  const data = {};
  data.email = email.value;
  data.bot = 0;
  if (
    role === "bride" ||
    role === "bridesmaid" ||
    role === "groomsman" ||
    role === "groom" ||
    role === "just shopping"
  ) {
    data.role = role;
  }
  if (weddingDate.value !== "") data.date = weddingDate.value;
  if (verify.value !== "") data.bot = "ROBOT";
  data.initialTS = initialTS;
  data.popupTS = popupTS;
  data.submitTS = Date.now();
  data.signupLocation = "popup";

  // Update text and listeners for email popup
  e.currentTarget.innerText = "SENDING";
  e.currentTarget.removeEventListener("click", submitEmailPopup);
  e.currentTarget.removeEventListener("keydown", window.enterEvent);

  // Analytics
  gtag({
    event: "email_popup_email_submitted",
    eventID: getEventId(),
    eventData: {
      roleSubmitted: data.role,
      weddingDateSubmitted: data.date,
      pagedTriggered: window.location.pathname,
    },
  });

  fetch(`${platformURL}/v1/customer/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((response) => {
      if (response.status !== 200) {
        button.addEventListener("click", submitEmailPopup);
        button.addEventListener("keydown", window.enterEvent);
        button.innerText = "SIGN UP";
        return;
      }
      const parent =
        button.parentElement.parentElement.parentElement.parentElement;
      parent.querySelectorAll(".popup-content").forEach((page) => {
        const { style } = page;

        if (!page.classList.contains("page-2")) {
          style.display = "none";
        } else {
          style.display = "flex";
          page.focus();
        }
      });
      localStorage.email = "email";
      trackLead(data.email, { signup_location: "popup", list_id: "Hj8m3A" });
      gtag({
        event: "email_popup_sms_screen_viewed",
        eventID: getEventId(),
        eventData: {
          pagedTriggered: window.location.pathname,
        },
      });
    })
    .catch(() => {
      button.addEventListener("click", submitEmailPopup);
      button.addEventListener("keydown", window.enterEvent);
      button.innerText = "SIGN UP";
    });
};

const allowCheck = document.getElementById("allowText");

if (allowCheck !== null) {
  allowCheck.addEventListener("change", function () {
    const self = this;
    if (self.checked && self.classList.contains("need-validation")) {
      self.classList.remove("need-validation");
    }
  });
}

const submitSmsPopup = async (e) => {
  const button = e.currentTarget;
  const phone = document.getElementById("PhoneNumber");
  const allowText = document.getElementById("allowText");
  let valid = true;

  // Validate phone number
  const phoneValue = phone.value.replace(/-/g, "");
  if (!validatePhone(phoneValue) || phone.value === "") {
    valid = false;
  }

  // Handle allowText not being checked — Temporarily remove for Suits waitlist activation
  // if (!allowText.checked) {
  //   allowText.classList.add("need-validation");
  //   valid = false;
  // }

  if (!valid) {
    phone.classList.add("check-validity");
    phone.labels[0].style.color = "var(--errorText)";
    phone.labels[0].style.opacity = "1";
    phone.focus();
    return;
  }

  // Phone validation passed
  const phoneValueFormatted = `+1${phoneValue}`;
  const data = {
    email: sessionStorage.getItem("customerEmail"),
    allowText: true,
    phone: phoneValueFormatted,
    bot: 0,
    initialTS,
    popupTS,
    submitTS: Date.now(),
  };

  // Update button state and remove event listeners
  button.innerText = "SENDING";
  button.removeEventListener("click", submitSmsPopup);
  button.removeEventListener("keydown", window.enterEvent);

  // Analytics
  gtag({
    event: "email_popup_sms_submitted",
    eventID: getEventId(),
    eventData: {
      pagedTriggered: window.location.pathname,
    },
  });

  try {
    const response = await fetch(`${platformURL}/v1/customer/sms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const result = await response.json();
      console.error("Failed reponse when submitting popup", result);

      // Update button state and re-add event listeners
      button.addEventListener("click", submitSmsPopup);
      button.addEventListener("keydown", window.enterEvent);
      button.innerText = "SIGN UP";
      return;
    }

    localStorage.email = "email";

    // Continue to the next popup page
    const container = button.closest(".popup-content");
    container.classList.add("hidden");
    container.nextElementSibling.classList.remove("hidden");
  } catch (error) {
    console.error("Error during SMS submission:", error);

    // Update button state and re-add event listeners
    button.addEventListener("click", submitSmsPopup);
    button.addEventListener("keydown", window.enterEvent);
    button.innerText = "SIGN UP";
  }
};

// Add `click` and `keydown (enter)` listener for submit button.
document.querySelectorAll(".popup-submit").forEach((submit) => {
  submit.addEventListener("click", submitEmailPopup);
  submit.addEventListener("keydown", window.enterEvent);
});

// Add `click` and `keydown (enter)` listener for SMS submit button.
document.querySelectorAll(".popup-submit-phone").forEach((submit) => {
  submit.addEventListener("click", submitSmsPopup);
  submit.addEventListener("keydown", window.enterEvent);
});

// Add `click` and `keydown (enter)` listeners for every close button.
document.querySelectorAll(".close-button").forEach((closeButton) => {
  closeButton.addEventListener("click", closePopup);
  closeButton.addEventListener("keydown", window.enterEvent);
});
